import { Link, useLocation } from "react-router-dom";

const ANALYSIS = [
  { to: "/", label: "Ask" },
  { to: "/partners", label: "Partners" },
  { to: "/reallocation", label: "Reallocation" },
  { to: "/benchmark", label: "Benchmark" },
  { to: "/need-funding", label: "Need vs funding" },
];

const PROVENANCE = [
  { to: "/data-trust", label: "Data & trust" },
];

export const Shell = ({ children }) => {
  const { pathname } = useLocation();
  const Tab = ({ to, label }) => {
    const active = to === "/" ? pathname === "/" : pathname.startsWith(to)
      || (to === "/data-trust" && ["/datasets", "/data-reality", "/audit", "/context"].some((p) => pathname.startsWith(p)));
    return (
      <Link
        to={to}
        data-testid={`nav-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        className={`relative px-3 py-2 text-[14px] transition-colors ${
          active ? "text-[#A01236] font-medium" : "text-stone-600 hover:text-stone-900"
        }`}
      >
        {label}
        {active && (
          <span className="absolute left-3 right-3 -bottom-px h-[2px] bg-[#A01236] rounded-full" />
        )}
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-[#FBF8F7] text-stone-900">
      <header className="sticky top-0 z-50 bg-[#FBF8F7]/92 backdrop-blur-md border-b border-stone-200">
        <div className="max-w-[1600px] mx-auto px-8 flex items-center gap-8">
          <Link to="/" className="flex items-center gap-3 py-3.5 shrink-0" data-testid="brand-home">
            <img src="/mgrant-logo.png" alt="mGrant" className="h-6 w-auto" />
            <span className="hidden lg:block w-px h-6 bg-stone-200" />
            <span className="hidden lg:block text-[14px] text-stone-600 leading-tight">
              Impact Intelligence
              <span className="block text-[12px] text-stone-600">Bajaj Finserv CSR</span>
            </span>
          </Link>

          <nav className="flex items-center gap-1 ml-auto flex-wrap" data-testid="main-nav">
            {ANALYSIS.map((n) => (
              <Tab key={n.to} {...n} />
            ))}
            <span className="w-px h-5 bg-stone-200 mx-2" />
            {PROVENANCE.map((n) => (
              <Tab key={n.to} {...n} />
            ))}
          </nav>
        </div>
      </header>

      <main className="max-w-[1600px] mx-auto px-8 py-10">{children}</main>

    </div>
  );
};

export const PageHeader = ({ overline, title, children, testId, actions }) => (
  <div className="mb-9 flex items-start justify-between gap-8 flex-wrap" data-testid={testId}>
    <div className="max-w-2xl">
      {overline && (
        <div className="text-[13px] font-semibold text-[#A01236]">
          {overline}
        </div>
      )}
      <h1 className="font-display text-[30px] leading-[1.18] font-bold tracking-tight mt-2">
        {title}
      </h1>
      {children && (
        <p className="text-[14px] text-stone-700 mt-3 leading-relaxed">{children}</p>
      )}
    </div>
    {actions}
  </div>
);

export const Loading = ({ label = "Computing" }) => (
  <div className="flex items-center gap-2.5 text-[14px] text-stone-600 py-16" data-testid="loading">
    <span className="w-3 h-3 border-2 border-stone-200 border-t-[#A01236] rounded-full animate-spin" />
    {label}…
  </div>
);

export const ErrorBox = ({ error }) => (
  <div className="border border-rose-200 bg-rose-50 rounded-xl p-5 text-[14px] text-rose-900" data-testid="error-box">
    {String(error?.message || error)}
  </div>
);
